/* ts-chips.js – Tomatosharp Organic V3
   Runde 57 (25/9 2026): knivtype-chips bytter innhold på stedet via Section Rendering API
   i stedet for full sideinnlasting. URL-ene er de samme (pushState), så lenker, deling og
   tilbake-knappen virker som før. Uten JS, eller ved feil, er chipsen en vanlig lenke.

   Seksjoner som byttes (id-ene leses fra DOM, ingen er hardkodet):
   - seksjonen rundt nav[data-ts-chips] (ts-kolleksjonstopp, har også brødsmulene i seg)
   - .shopify-section--ts-brodsmuler hvis den finnes som egen seksjon (ikke på kolleksjonsmalen i dag)
   - .shopify-section--main-collection (gridet, filtre, sortering, «Vis flere»)
*/
(function () {
  'use strict';
  // Runde 57: scriptet ligger i kolleksjonstoppen og kommer med på nytt når seksjonen byttes. Bare én oppstart.
  if (window.__tsChips) return;
  window.__tsChips = true;
  if (!window.fetch || !window.DOMParser || !window.history || !history.pushState) return;
  if (window.Shopify && window.Shopify.designMode) return; // temaeditoren laster seksjoner selv

  var PREFIKS = 'shopify-section-';
  var MAKS_CACHE = 10;
  var LEVETID = 2 * 60 * 1000; // lagerstatus kan endre seg; eldre forhåndshenting kastes
  var cache = new Map(); // fetch-URL -> { t, p: Promise<json> }
  var teller = 0; // siste klikk vinner ved rask veksling
  var harByttet = false;
  var sistVist = location.pathname + location.search;

  function redusertBevegelse() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function seksjonId(el) {
    var s = el && el.closest('.shopify-section');
    return s && s.id.indexOf(PREFIKS) === 0 ? s.id.slice(PREFIKS.length) : null;
  }

  function finnIder() {
    var nav = document.querySelector('nav[data-ts-chips]');
    var ider = [];
    [
      nav,
      document.querySelector('.shopify-section--ts-brodsmuler'),
      document.querySelector('.shopify-section--main-collection')
    ].forEach(function (el) {
      var id = seksjonId(el);
      if (id && ider.indexOf(id) === -1) ider.push(id);
    });
    // Uten kolleksjonstopp og grid er det ingenting å bytte trygt.
    var hovedId = seksjonId(document.querySelector('.shopify-section--main-collection'));
    return seksjonId(nav) && hovedId ? ider : null;
  }

  // Ny knivtype = nytt utgangspunkt: filter, side og sortering følger ikke med.
  function renUrl(href) {
    var u = new URL(href, location.href);
    Array.from(u.searchParams.keys()).forEach(function (k) {
      if (k.indexOf('filter.') === 0 || k === 'page' || k === 'sections' || k === 'section_id') u.searchParams.delete(k);
    });
    u.hash = '';
    return u;
  }

  function hentUrl(sideUrl, ider) {
    var u = new URL(sideUrl.toString());
    u.searchParams.set('sections', ider.join(','));
    return u.toString();
  }

  function hent(sideUrl, ider, lav) {
    var key = hentUrl(sideUrl, ider);
    var treff = cache.get(key);
    if (treff && Date.now() - treff.t < LEVETID) return treff.p;
    // Runde 57: IKKE send Accept: application/json – da svarer Shopify med kolleksjons-JSON (som /collections/x.json)
    // i stedet for seksjonene. Standard Accept gir Section Rendering-svaret.
    var init = { credentials: 'same-origin' };
    if (lav) init.priority = 'low';
    var p = fetch(key, init).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (data) {
      ider.forEach(function (id) {
        if (!data || typeof data[id] !== 'string') throw new Error('Mangler seksjon ' + id);
      });
      return data;
    });
    p.catch(function () { cache.delete(key); });
    cache.delete(key);
    cache.set(key, { t: Date.now(), p: p });
    while (cache.size > MAKS_CACHE) cache.delete(cache.keys().next().value);
    return p;
  }

  // Script satt inn med innerHTML kjører ikke. main-collection har ingen inline-script i dag (Runde 57),
  // men blir det lagt til, kjøres de her. Eksterne script som alt er lastet (f.eks. denne fila) hoppes over.
  function kjorScript(rot, lastet) {
    rot.querySelectorAll('script').forEach(function (gammel) {
      var type = (gammel.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'module' && type !== 'application/javascript') return;
      if (gammel.src && lastet.has(gammel.src)) return;
      var ny = document.createElement('script');
      Array.from(gammel.attributes).forEach(function (a) { ny.setAttribute(a.name, a.value); });
      ny.textContent = gammel.textContent;
      gammel.replaceWith(ny);
    });
  }

  function headerHoyde() {
    var rot = getComputedStyle(document.documentElement);
    var h = parseFloat(rot.getPropertyValue('--header-height'));
    if (isNaN(h)) {
      var header = document.querySelector('header, .shopify-section--header');
      h = header ? header.getBoundingClientRect().height : 0;
    }
    var sticky = rot.getPropertyValue('--header-is-sticky').trim();
    if (sticky === '0') h = 0;
    var bar = parseFloat(rot.getPropertyValue('--announcement-bar-height')) || 0;
    var barSticky = parseFloat(rot.getPropertyValue('--announcement-bar-is-sticky')) || 0;
    return h + bar * barSticky;
  }

  function visTopp(h1) {
    if (!h1) return;
    var topp = headerHoyde() + 16;
    var r = h1.getBoundingClientRect();
    if (r.top < topp || r.top > window.innerHeight * 0.6) {
      window.scrollTo({ top: window.pageYOffset + r.top - topp, behavior: redusertBevegelse() ? 'auto' : 'smooth' });
    }
    h1.setAttribute('tabindex', '-1');
    try { h1.focus({ preventScroll: true }); } catch (e) { h1.focus(); }
  }

  // Mobil: chipsene ligger i en vannrett rulleliste. Behold rulleposisjonen og hold aktiv chip synlig.
  function holdChipSynlig(scrollLeft) {
    var nav = document.querySelector('nav[data-ts-chips]');
    if (!nav) return;
    nav.scrollLeft = scrollLeft;
    var aktiv = nav.querySelector('[aria-current="page"]');
    if (!aktiv) return;
    var n = nav.getBoundingClientRect();
    var c = aktiv.getBoundingClientRect();
    if (c.left < n.left || c.right > n.right) nav.scrollLeft += c.left - n.left - 16;
  }

  function settAktiv(chip) {
    var nav = chip.closest('nav[data-ts-chips]');
    if (!nav) return;
    nav.querySelectorAll('.ts-chip').forEach(function (a) {
      var er = a === chip;
      a.classList.toggle('ts-chip--aktiv', er);
      if (er) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
  }

  function lastInn(sideUrl, opts) {
    var ider = finnIder();
    if (!ider) { location.href = sideUrl.toString(); return; }
    var mitt = ++teller;
    var nav = document.querySelector('nav[data-ts-chips]');
    var hoved = document.querySelector('.shopify-section--main-collection');
    var scrollLeft = nav ? nav.scrollLeft : 0;
    var gammelTittel = document.querySelector('.ts-kolltopp__tittel');
    gammelTittel = gammelTittel ? gammelTittel.textContent.trim() : '';
    if (nav) nav.classList.add('is-loading');
    if (hoved) hoved.setAttribute('aria-busy', 'true');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    function rydd() {
      var n = document.querySelector('nav[data-ts-chips]');
      if (n) n.classList.remove('is-loading');
      var h = document.querySelector('.shopify-section--main-collection');
      if (h) h.removeAttribute('aria-busy');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }

    hent(sideUrl, ider, false).then(function (data) {
      if (mitt !== teller) return; // et nyere klikk har tatt over
      var parser = new DOMParser();
      var lastet = new Set(Array.from(document.scripts, function (s) { return s.src; }).filter(Boolean));
      // Parse alt før noe byttes, så en ødelagt seksjon ikke gir halvbyttet side.
      var par = ider.map(function (id) {
        var mal = document.getElementById(PREFIKS + id);
        var doc = parser.parseFromString(data[id], 'text/html');
        var kilde = doc.getElementById(PREFIKS + id) || doc.body.firstElementChild;
        if (!mal || !kilde) throw new Error('Fant ikke seksjon ' + id);
        return [mal, kilde];
      });
      if (opts.push) history.pushState({ tsChips: true }, '', sideUrl.toString());
      harByttet = true;
      sistVist = location.pathname + location.search;
      par.forEach(function (p) {
        p[0].innerHTML = p[1].innerHTML;
        kjorScript(p[0], lastet);
      });
      rydd();

      // Runde 57: kolleksjonstoppen bærer sidens SEO-tittel (page_title) i data-ts-sidetittel, så
      // document.title blir samme som ved full innlasting. H1 er reserve.
      var navNy = document.querySelector('nav[data-ts-chips]');
      var seoTittel = navNy && navNy.getAttribute('data-ts-sidetittel');
      var h1 = document.querySelector('.ts-kolltopp__tittel') || document.querySelector('main h1, h1');
      if (h1) {
        var ny = h1.textContent.trim();
        // 4/10 2026: samme regel som <title> i theme.liquid. Før ble butikknavnet lest ut av gjeldende tittel med regex,
        // og en SEO-tittel med «–» og «| Tomatosharp» ga «… – håndplukket i Japan | Tomatosharp» på neste kolleksjon.
        var butikk = 'Tomatosharp';
        if (seoTittel) document.title = seoTittel.indexOf(butikk) > -1 ? seoTittel : seoTittel + ' – ' + butikk;
        else if (ny && ny !== gammelTittel) document.title = ny + ' – ' + butikk;
      }
      holdChipSynlig(scrollLeft);
      oppdaterMaske();
      koblet(); // Runde 85 (20/10 2026): R10, ny rad etter bytte
      visTopp(h1);
      document.dispatchEvent(new CustomEvent('ts:chips:byttet', { detail: { url: sideUrl.toString(), sections: ider } }));
    }).catch(function () {
      if (mitt !== teller) return;
      rydd();
      // Vanlig navigasjon. Ved tilbake/fram er URL-en alt byttet, så last siden på nytt.
      if (opts.push) location.href = sideUrl.toString(); else location.reload();
    });
  }

  // Runde 65 (26/9 2026): bare chips som peker på en kolleksjon byttes på stedet. «Alle knivtyper» går til
  // /pages/knivtyper, som ikke har kolleksjonsseksjonene, og skal lastes som en vanlig side.
  function erKolleksjon(a) {
    return a.origin === location.origin && /\/collections\//.test(a.pathname);
  }

  function erVanligKlikk(e, a) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    return erKolleksjon(a);
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('nav[data-ts-chips] a.ts-chip');
    if (!chip || !erVanligKlikk(e, chip)) return;
    var sideUrl = renUrl(chip.href);
    e.preventDefault();
    // Samme knivtype uten filter: ingenting å hente.
    if (sideUrl.pathname + sideUrl.search === location.pathname + location.search) return;
    settAktiv(chip); // straks-respons; serverens HTML overstyrer når den kommer
    lastInn(sideUrl, { push: true });
  });

  // Forhåndshenting når pekeren eller fingeren treffer en chip. Klikket bruker samme løfte.
  function forhand(e) {
    var chip = e.target.closest && e.target.closest('nav[data-ts-chips] a.ts-chip');
    if (!chip || !erKolleksjon(chip) || chip.getAttribute('aria-current') === 'page') return;
    if (navigator.connection && navigator.connection.saveData) return;
    var ider = finnIder();
    if (!ider) return;
    hent(renUrl(chip.href), ider, true).catch(function () {});
  }
  document.addEventListener('pointerover', forhand, { passive: true });
  document.addEventListener('touchstart', forhand, { passive: true });
  document.addEventListener('focusin', forhand);

  window.addEventListener('popstate', function () {
    // Bare når denne siden har byttet innhold selv; hash-endringer og andre skript rører vi ikke.
    if (!harByttet) return;
    if (location.pathname + location.search === sistVist) return;
    lastInn(new URL(location.href), { push: false });
  });

  // Runde 84 (20/10 2026): masken til høyre bare når raden faktisk kan rulle videre.
  // data-ts-slutt settes ved enden og når raden ikke ruller; ts-custom.css slår masken av da.
  function oppdaterMaske() {
    var nav = document.querySelector('nav[data-ts-chips]');
    if (!nav) return;
    nav.toggleAttribute('data-ts-slutt', nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 1);
  }
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('nav[data-ts-chips]')) oppdaterMaske();
  }, true);
  window.addEventListener('resize', oppdaterMaske);

  /* Runde 85 (20/10 2026): R10. Vanlig musehjul (loddrett) ruller chips-raden sidelengs når pekeren står over den. I endene, og når raden
     ikke kan rulle, går hjulet videre til siden som før. Styreflatens sidelengs sveip (deltaX) og ctrl+hjul (zoom) rører vi ikke.
     Lytteren sitter på raden, ikke på dokumentet, så vanlig siderulling ellers ikke venter på skript. Raden byttes ved hvert chipsklikk,
     derfor kobles den til på nytt etter bytte (koblet() i lastInn). */
  function hjul(e) {
    var nav = e.currentTarget;
    if (e.ctrlKey || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    var maks = nav.scrollWidth - nav.clientWidth;
    var dy = e.deltaMode === 1 ? e.deltaY * 40 : e.deltaY;
    if (maks <= 1 || (dy < 0 && nav.scrollLeft <= 0) || (dy > 0 && nav.scrollLeft >= maks - 1)) return;
    nav.scrollLeft += dy;
    e.preventDefault();
  }
  function koblet() {
    var nav = document.querySelector('nav[data-ts-chips]');
    if (!nav || nav.__tsHjul) return;
    nav.__tsHjul = true;
    nav.addEventListener('wheel', hjul, { passive: false });
  }

  // Direkte lasting (meny, delt lenke): vis aktiv chip med en gang.
  holdChipSynlig(0);
  oppdaterMaske();
  koblet();
})();
